import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: true,
    error: null,
    partnerConnections: [],
    selectedPartners: [],
    vendorIntegration: {
        vendorIntegrationData: {},
    }
};
const venderIntegration = createSlice({
    name: 'venderIntegration',
    initialState,
    reducers: {
        createVendorIntegrationData(state, action) {
            const { selectedPartners, connections } = action.payload;
    
            const updatedIntegrationData = selectedPartners.reduce((data, element) => {
                const connected = connections.find(connection =>
                    connection.partner_id === element.id && connection.selected_in_csp === 1
                );
    
                const key = element.name;
                data[key] = {
                    partner_id: element.id,
                    id: connected?.id || '',
                    selectedConnection: connected?.name || '',
                    name: connected?.name || '',
                    sftp_host: connected?.sftp_host || '',
                    sftp_user: connected?.sftp_user || '',
                    sftp_password: '',
                    sftp_path: connected?.sftp_path || '',
                    sftp_archive_path: connected?.sftp_archive_path || '',
                    selected: 0
                };
    
                return data;
            }, {});
    
            return {
                ...state,
                vendorIntegration: {
                    ...state.vendorIntegration,
                    vendorIntegrationData: updatedIntegrationData
                }
            };
        },
    
        handleConnection(state, action) {
            const { category, selectedOption } = action.payload;
            const isNewConnection = selectedOption.label === "New Connection";
    
            const updatedData = isNewConnection
                ? {
                      ...state.vendorIntegration.vendorIntegrationData[category],
                      id: null,
                      name: '',
                      partner_id: selectedOption.connection.partner_id,
                      selected_in_csp: '',
                      sftp_archive_path: '',
                      sftp_host: '',
                      sftp_path: '',
                      sftp_user: '',
                      selectedConnection: 'New Connection',
                      sftp_password: '',
                      selected: 0
                  }
                : {
                      ...state.vendorIntegration.vendorIntegrationData[category],
                      partner_id: selectedOption.connection[0].partner_id,
                      id: selectedOption.connection[0].id,
                      selectedConnection: selectedOption.connection[0].name,
                      name: selectedOption.connection[0].name,
                      sftp_password: '',
                      sftp_host: selectedOption.connection[0].sftp_host,
                      sftp_user: selectedOption.connection[0].sftp_user,
                      sftp_path: selectedOption.connection[0].sftp_path,
                      sftp_archive_path: selectedOption.connection[0].sftp_archive_path,
                      selected: 0
                  };
    
            const updatedVendorIntegrationData = {
                ...state.vendorIntegration.vendorIntegrationData,
                [category]: updatedData
            };
    
            return {
                ...state,
                vendorIntegration: {
                    ...state.vendorIntegration,
                    vendorIntegrationData: updatedVendorIntegrationData
                }
            };
        },
    
        handleInputChange(state, action) {
            const { category, field, value } = action.payload;
    
            const currentValue = state.vendorIntegration.vendorIntegrationData[category][field];
            if (currentValue === value) {
                return state;
            }
    
            const updatedData = {
                ...state.vendorIntegration.vendorIntegrationData[category],
                [field]: value
            };
    
            const dataChanged = Object.keys(updatedData).some(
                key => updatedData[key] !== state.vendorIntegration.vendorIntegrationData[category][key]
            );
            const selected = dataChanged ? 1 : 0;
            return {
                ...state,
                vendorIntegration: {
                    ...state.vendorIntegration,
                    vendorIntegrationData: {
                        ...state.vendorIntegration.vendorIntegrationData,
                        [category]: {
                            ...updatedData,
                            selected
                        }
                    }
                }
            };
        }
        
    },
});

export const { actions } = venderIntegration;
export default venderIntegration.reducer;
